import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

/**
 * This hook will update the url part of the meta tag with name `apple-itunes-app`, maintaining the utm search parameters and the rest of the content part, when the location changes
 */
const useSmartBannerUpdater = () => {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const meta = document.querySelector('meta[name="apple-itunes-app"]');
      if (meta) {
        const utmContent = meta.content.substring(meta.content.indexOf('utm_source'));
        const contentStart = meta.content.substring(0, meta.content.indexOf('app-argument'));
        const {origin, pathname} = window.location;
        const newUrl = new URL(pathname, origin);
        newUrl.search = utmContent;

        meta.content = `${contentStart}app-argument=${newUrl.toString()}`;
      }
    }
  }, [location]);
};

export default useSmartBannerUpdater;
